import { AbstractResponse } from "src/models/api";

export interface IQualityReview {
  ID: number;
  caseID: number;
  providerID: number;
  clientID: number;
  locationID: number;
  medicalDirectorFlag: boolean;
  medicalDirectorComment: string | null;
  answers: IQualityReviewAnswer[];
  comments: string | null;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  createdBy: number;
  updatedBy: number;
  deletedBy: number | null;
}

export interface IQualityReviewAnswer {
  ID: number;
  qualityReviewID: number;
  question: string;
  score: number | null;
  notes: string | null;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  createdBy: number;
  updatedBy: number;
  deletedBy: number | null;
}

export interface IQualityReviewResponse {
  ID: number;
  caseID: number;
  providerID: number;
  clientID: number;
  locationID: number;
  medicalDirectorFlag: boolean;
  medicalDirectorComment: string | null;
  answers: IQualityReviewAnswerResponse[];
  comments: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  createdBy: number;
  updatedBy: number;
  deletedBy: number | null;
}

export interface IQualityReviewAnswerResponse {
  ID: number;
  qualityReviewID: number;
  question: string;
  score: number | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  createdBy: number;
  updatedBy: number;
  deletedBy: number | null;
}

export class QualityReview extends AbstractResponse implements IQualityReview {
  ID: number;
  caseID: number;
  providerID: number;
  clientID: number;
  locationID: number;
  medicalDirectorFlag: boolean;
  medicalDirectorComment: string | null;
  answers: IQualityReviewAnswer[];
  comments: string | null;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  createdBy: number;
  updatedBy: number;
  deletedBy: number | null;

  requiredFields: string[] = [
    "ID",
    "caseID",
    "providerID",
    "clientID",
    "locationID",
    "medicalDirectorFlag",
    "answers",
    "createdAt",
    "updatedAt",
    "createdBy",
    "updatedBy"
  ];

  booleanFields: string[] = [
    "medicalDirectorFlag"
  ];

  stringFields: string[] = [
    "medicalDirectorComment",
    "comments"
  ];

  numberFields: string[] = [
    "ID",
    "caseID",
    "providerID",
    "clientID",
    "locationID",
    "createdBy",
    "updatedBy",
    "deletedBy"
  ];

  dateFields: string[] = [
    "createdAt",
    "updatedAt",
    "deletedAt"
  ];

  constructor(data: IQualityReviewResponse) {
    super(data);
    this.ID = data.ID;
    this.caseID = data.caseID;
    this.providerID = data.providerID;
    this.clientID = data.clientID;
    this.locationID = data.locationID;
    this.medicalDirectorFlag = data.medicalDirectorFlag;
    this.medicalDirectorComment = data.medicalDirectorComment;
    this.answers = data.answers.map((answer) => new QualityReviewAnswer(answer));
    this.comments = data.comments;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.deletedAt = data.deletedAt ? new Date(data.deletedAt) : null;
    this.createdBy = data.createdBy;
    this.updatedBy = data.updatedBy;
    this.deletedBy = data.deletedBy;
  }
}

export class QualityReviewAnswer extends AbstractResponse implements IQualityReviewAnswer {
  ID: number;
  qualityReviewID: number;
  question: string;
  notes: string | null;
  score: number | null;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  createdBy: number;
  updatedBy: number;
  deletedBy: number | null;

  requiredFields: string[] = [
    "ID",
    "qualityReviewID",
    "question",
    "answer",
    "createdAt",
    "updatedAt",
    "createdBy",
    "updatedBy"
  ];

  booleanFields: string[] = [];

  stringFields: string[] = [
    "answer"
  ];

  numberFields: string[] = [
    "ID",
    "qualityReviewID",
    "question",
    "createdBy",
    "updatedBy",
    "deletedBy"
  ];

  dateFields: string[] = [
    "createdAt",
    "updatedAt",
    "deletedAt"
  ];

  constructor(data: IQualityReviewAnswerResponse) {
    super(data);
    this.ID = data.ID;
    this.qualityReviewID = data.qualityReviewID;
    this.question = data.question;
    this.notes = data.notes;
    this.score = data.score;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.deletedAt = data.deletedAt ? new Date(data.deletedAt) : null;
    this.createdBy = data.createdBy;
    this.updatedBy = data.updatedBy;
    this.deletedBy = data.deletedBy;
  }
}

export interface IQualityReviewAnswerRequest {
  question: string;
  score: number | null;
  notes: string | null;
}

export interface IQualityReviewRequest {
  caseID: number;
  providerID: number;
  clientID: number;
  locationID: number;
  medicalDirectorFlag: boolean;
  medicalDirectorComment: string | null;
  answers: IQualityReviewAnswerRequest[];
  comments: string | null;
}


